import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'vias-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss']
})
export class ProgressSpinnerComponent implements OnInit {
  @Input() run: boolean = true;
  @Input() value: number = 100;
  @Input() diameter: number = 70;
  @Input() mode: string = 'indeterminate';
  @Input() strokeWidth: number = 8;
  @Input() overlay: boolean = true;
  @Input() color: string = 'primary';
  
  constructor() { }

  ngOnInit(): void {
  }

}
